import { c as _c } from "react/compiler-runtime";
/* eslint-disable default-param-last */
import { toRecord } from '@newfront-insurance/core';
import type { LineOfCoverageTypeDefinition, LineOfCoverageType, PolicyTypeDefinition, PolicyType } from '@newfront-insurance/coverage-api';
import type { NextApiError } from '@newfront-insurance/next-api-error';
import type { NextApiSubscription, ConfigInterface } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext, useMemo, useCallback } from 'react';
import { routes } from '../bff/routes';
import type { GetDefinitionsParams, GetDefinitionsResponse } from '../bff/types';
import { CoverageApiContext } from '../provider';
function useDefinitions(t0, config) {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const params = t1;
  const {
    basePath
  } = useContext(CoverageApiContext);
  let t2;
  if ($[2] !== basePath || $[3] !== params) {
    t2 = routes.definitions.getUrl(params, basePath);
    $[2] = basePath;
    $[3] = params;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useNextApiSubscription(t2, config);
}
export interface DefinitionsHelpers {
  loading: boolean;
  error?: NextApiError;
  lineOfCoverageTypes: LineOfCoverageType[];
  lineOfCoverageTypeDefinitions: Record<LineOfCoverageType, LineOfCoverageTypeDefinition>;
  policyTypes: PolicyType[];
  policyTypeDefinitions: Record<PolicyType, PolicyTypeDefinition>;
  renderPolicyType: (policyType: PolicyType) => string;
  renderLineOfCoverageType: (lineOfCoverageType: LineOfCoverageType) => string;
}

/**
 * @deprecated Use `admin-ui/coverage` LOC and Policy definitions helpers instead.
 */
export function useDefinitionsHelpers(t0, config) {
  const $ = _c(27);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const params = t1;
  const {
    data,
    error
  } = useDefinitions(params, config);
  let t2;
  let t3;
  if ($[2] !== data?.linesOfCoverage) {
    t3 = data?.linesOfCoverage ?? [];
    $[2] = data?.linesOfCoverage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  t2 = t3;
  const locDefinitionsArray = t2;
  let t4;
  let t5;
  if ($[4] !== data?.policyTypes) {
    t5 = data?.policyTypes ?? {};
    $[4] = data?.policyTypes;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const policyTypeDefinitions = t4;
  let t6;
  let t7;
  if ($[6] !== locDefinitionsArray) {
    t7 = locDefinitionsArray.map(_temp);
    $[6] = locDefinitionsArray;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  t6 = t7;
  const lineOfCoverageTypes = t6;
  let t8;
  let t9;
  if ($[8] !== locDefinitionsArray) {
    t9 = locDefinitionsArray || [];
    $[8] = locDefinitionsArray;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = toRecord(t9, _temp2);
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  t8 = t10;
  const lineOfCoverageTypeDefinitions = t8;
  let t11;
  let t12;
  if ($[12] !== policyTypeDefinitions) {
    t12 = Object.keys(policyTypeDefinitions);
    $[12] = policyTypeDefinitions;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  t11 = t12;
  const policyTypes = t11;
  let t13;
  if ($[14] !== policyTypeDefinitions) {
    t13 = type => policyTypeDefinitions[type]?.readableName || type;
    $[14] = policyTypeDefinitions;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const renderPolicyType = t13;
  let t14;
  if ($[16] !== lineOfCoverageTypeDefinitions) {
    t14 = type_0 => lineOfCoverageTypeDefinitions[type_0]?.readableName || type_0;
    $[16] = lineOfCoverageTypeDefinitions;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const renderLineOfCoverageType = t14;
  const t15 = !data && !error;
  let t16;
  if ($[18] !== error || $[19] !== lineOfCoverageTypeDefinitions || $[20] !== lineOfCoverageTypes || $[21] !== policyTypeDefinitions || $[22] !== policyTypes || $[23] !== renderLineOfCoverageType || $[24] !== renderPolicyType || $[25] !== t15) {
    t16 = {
      loading: t15,
      error,
      lineOfCoverageTypes,
      lineOfCoverageTypeDefinitions,
      policyTypes,
      policyTypeDefinitions,
      renderPolicyType,
      renderLineOfCoverageType
    };
    $[18] = error;
    $[19] = lineOfCoverageTypeDefinitions;
    $[20] = lineOfCoverageTypes;
    $[21] = policyTypeDefinitions;
    $[22] = policyTypes;
    $[23] = renderLineOfCoverageType;
    $[24] = renderPolicyType;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}
function _temp2(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}
function _temp(t0) {
  const {
    id
  } = t0;
  return id;
}